import React from 'react';
import styles from './Agendar.module.css';
import logo from './images/LOGO-BLANCO--SIN-LETRAS-HD.webp';
import { useNavigate } from 'react-router-dom';

const Agendar = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.agendarContainer}>
      <div className={styles.contentWrapper}>
        <div className={styles.textContent}>
          <h1 className={styles.title}>
          <span className={styles.titleHighlight1}>Agenda una </span> <span className={styles.titleHighlight2}>Demo</span>
          </h1>
          <p className={styles.subtitle}>
            Contáctanos para desarrollar tu solución personalizada.
          </p>
          <a className={styles.agendarButton} onClick={() => navigate('/contacto')}>
            Agendar
          </a>
        </div>
        <div className={styles.imageContainer}>
          <img src={logo} alt="Logo" className={styles.logo} />
        </div>
      </div>
    </div>
  );
};

export default Agendar;